<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="baseView.mode"
    :tabs="tabs"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :selectedIndex="selectedIndex"
    :formsConfig="formsConfig"
    :hot-key-grid-tab-index="1"
  >
    <template #headerContent>
      <GcHeaderContentStatic title="Create Stocktake" />
    </template>
    <div class="item-price-update">
      <gc-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
      >
        <template #leftContent>
          <dx-data-grid
            :data-source="stocktakeBranchDataSourceConfig"
            :columns="branchGridColumns"
            :ref="'stocktake-branch-grid'"
            :height="gridHeight"
            @toolbar-preparing="onToolbarPreparingStocktakeBranchGrid"
            @selection-changed="onBranchGridSelectionChanged"
            :selection="{
              mode: 'multiple',
              selectAllMode: 'allPages',
              showCheckBoxesMode: 'always',
            }"
          >
          </dx-data-grid>
        </template>

        <template #rightContent>
          <dx-data-grid
            :columns="stocktakeGridColumns"
            :data-source="stocktakeDataSourceConfig"
            :selection="{
              mode: 'multiple',
              selectAllMode: 'allPages',
              showCheckBoxesMode: 'always',
            }"
            @selection-changed="onStocktakeGridSelectionChanged"
            :height="gridHeight - toolBarHeight"
            :ref="'stocktake-grid'"
            @toolbar-preparing="onToolbarPreparingStocktakeGrid"
            @content-ready="addGridNoResults($event)"
          >
            <template #item-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data[currentDescriptionDataField]"
                :code="data.data.Code"
              />
            </template>
          </dx-data-grid>
        </template>
      </gc-split-view>
    </div>
  </gc-main-layout>
</template>

<script>
let stocktakeBranchDataSource = StocktakePrepareService.dataSourceConfig(
  "api/Branch",
  {
    key: "Code",
    preventPagination: true,
    sort: [{ selector: "Code", asc: true }],
    filter: [["Inactive", "=", "N"]],
  }
);

let stocktakeCategory1DataSource = StocktakePrepareService.dataSourceConfig(
  "api/ProductCategory1",
  {
    key: "Code",
    preventPagination: true,
    // sort: [{ selector: "Code", asc: true }],
    filter: [["Inactive", "=", "N"]],
  }
);
let stocktakeCategory2DataSource = StocktakePrepareService.dataSourceConfig(
  "api/ProductCategory2",
  {
    key: "Code",
    preventPagination: true,
    // sort: [{ selector: "Code", asc: true }],
    filter: [["Inactive", "=", "N"]],
  }
);
let stocktakeCategory3DataSource = StocktakePrepareService.dataSourceConfig(
  "api/ProductCategory3",
  {
    key: "Code",
    preventPagination: true,
    // sort: [{ selector: "Code", asc: true }],
    filter: [["Inactive", "=", "N"]],
  }
);
let stocktakeItemDataSource = StocktakePrepareService.dataSourceConfig(
  "api/Product",
  {
    key: "Code",
    preventPagination: true,
    // sort: [{ selector: "Code", asc: true }],
    filter: [["Inactive", "=", "N"]],
  }
);
let stocktakeSupplierDataSource = StocktakePrepareService.dataSourceConfig(
  "api/Supplier",
  {
    key: "Code",
    preventPagination: true,
    // sort: [{ selector: "Code", asc: true }],
    filter: [["Inactive", "=", "N"]],
  }
);

import BaseViewMixin from "../../v1/_mixins/base.view";
import { StocktakePrepareService } from "../../_services/api/inventory/stocktake-prepare.service";
import validationEngine from "devextreme/ui/validation_engine";

export default {
  props: {},
  mixins: [BaseViewMixin],
  data() {
    return {
      currentView: null,
      stocktakeBranchDataSourceConfig: [],
      stocktakeDataSourceConfig: [],
      branchGridSelectedData: [],
      stocktakeGridSelectedData: [],
      toolBarHeight: 0,
      isItemSelected: false,
      MinCountDate: null,
      model: {
        View: "",
        CountDate: null,
      },
    };
  },
  components: {},
  async created() {
    stocktakeBranchDataSource.load().then(() => {
      this.stocktakeBranchDataSourceConfig = stocktakeBranchDataSource.items();
    });
    this.model.CountDate = new Date();
    await this.setActiveAccountingPeriod();
    this.stocktakeBranchGrid.repaint();
  },
  computed: {
    noDataMessage() {
      let noDataMessageObject = {
        addNew: {},
      };
      if (this.currentView == "Item") {
        noDataMessageObject.addNew = {
          class: "no-data",
          title: "No Product Lines",
          message:
            "Products must be marked Active to appear here. Head over to the Product screen to adjust this setting.",
        };
      } else if (this.currentView == "Supplier") {
        noDataMessageObject.addNew = {
          class: "no-data",
          title: "No Supplier Lines",
          message:
            "Suppliers must be marked Active to appear here. Head over to the Supplier screen to adjust this setting.",
        };
      } else {
        noDataMessageObject.addNew = {
          class: "add-new hide",
          title: "",
          message: "Select a View for records to appear here",
        };
      }
      return noDataMessageObject;
    },
    getTomorrowDate() {
      let tomorrow = new Date();
      tomorrow.setDate(new Date().getDate() + 1);
      return tomorrow;
    },
    stocktakeGrid() {
      return this.$refs["stocktake-grid"]
        ? this.$refs["stocktake-grid"].instance
        : null;
    },
    stocktakeBranchGrid() {
      return this.$refs["stocktake-branch-grid"]
        ? this.$refs["stocktake-branch-grid"].instance
        : null;
    },
    branchGridToolbarItems() {
      return [
        {
          dataField: "CountDate",
          editorType: "dxDateBox",
          editorOptions: {
            displayFormat: "dd MMM yyyy",
            width: 120,
            min: this.MinCountDate,
            max: this.getTomorrowDate,
          },
          validationRules: [
            {
              type: "required",
              message: "Count Date is required",
            },
          ],
        },
      ];
    },
    toolbarDetailsFormItems() {
      return [
        {
          dataField: "View",
          editorType: "dxSelectBox",
          editorOptions: {
            width: 200,
            items: [
              {
                value: "Prod Cat 1",
                text: "Category 1",
              },
              {
                value: "Prod Cat 2",
                text: "Category 2",
              },
              {
                value: "Prod Cat 3",
                text: "Category 3",
              },
              {
                value: "Supplier",
                text: "Supplier",
              },
              {
                value: "Item",
                text: "Item",
              },
            ],
            displayExpr: "text",
            valueExpr: "value",
            value: this.currentView,
            onValueChanged: this.viewChanged.bind(this),
            disabled: this.isItemSelected,
          },
        },
      ];
    },
    currentDescriptionDataField() {
      if (this.currentView === "Supplier") {
        return "Name";
      } else if (this.currentView === "Item") {
        return "Description1";
      } else {
        return "Description";
      }
    },
    branchGridColumns() {
      return this.parseGridColumns("transaction", [
        {
          gcLabel: "Branch",
          dataField: "Description",
          gcType: "String",
          gcSubType: "PrimaryRecord",
        },
      ]);
    },
    stocktakeGridColumns() {
      return this.parseGridColumns("transaction", [
        {
          gcLabel: "Item",
          dataField: this.currentDescriptionDataField,
          cellTemplate: "item-cell-template",
          gcType: "String",
          gcSubType: "PrimaryRecord",
        },
        {
          gcLabel: "Item",
          dataField: "Code",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode",
        },
        {
          gcLabel: "Description",
          dataField: this.currentDescriptionDataField,
          minWidth: this.gridColumnMinWidth(220),
          gcType: "String",
          gcSubType: "HiddenDescription",
        },
      ]);
    },

    tabs() {
      return [
        {
          text: "Prepare",
          path: `/stocktake/create`,
          applicationFeatureCode: "StocktakeManagement",
        },
        {
          text: "Count",
          path: ``,
          applicationFeatureCode: "",
          disabled: true,
        },
        {
          text: "Review",
          path: ``,
          applicationFeatureCode: "",
          disabled: true,
        },
      ];
    },
    showLeftContainer() {
      return !(this.isXSmall && this.baseView.mode !== "");
    },
    showRightContainer() {
      return !(this.baseView.mode == "review" && this.baseView.id == "");
    },
  },
  watch: {
    stocktakeGridSelectedData(selectedDataArr) {
      if (selectedDataArr.length > 0) this.isItemSelected = true;
      else this.isItemSelected = false;
      this.stocktakeGrid.repaint();
    },
  },
  methods: {
    async setActiveAccountingPeriod() {
      let startDateResult = await StocktakePrepareService.getActiveAccountingPeriodStartDate();
      if (startDateResult) {
        let accountingPeriod = startDateResult.data.value[0];
        this.MinCountDate = new Date(accountingPeriod.StartDate);
      }
    },
    onBranchGridSelectionChanged({ selectedRowsData }) {
      this.branchGridSelectedData = selectedRowsData;
    },
    onStocktakeGridSelectionChanged(e) {
      this.stocktakeGridSelectedData = e.selectedRowsData;
    },
    backButtonFunction() {
      this.$router.push({
        path: "/stocktake",
      });
    },
    onToolbarPreparingStocktakeBranchGrid(e) {
      let toolbarItems = e.toolbarOptions.items;
      let searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });

      let itemsToRemoveFromToolBar = [
        "searchPanel",
        "revertButton",
        "saveButton",
      ];

      e.toolbarOptions.items = toolbarItems.filter(
        (item) => !itemsToRemoveFromToolBar.includes(item.name)
      );

      searchPanel.location = "after";

      e.toolbarOptions.items.unshift(
        searchPanel,

        {
          widget: "dxForm",
          location: "before",
          disabled: this.baseView.mode == "review" ? true : false,
          options: {
            formData: this.model,
            items: this.branchGridToolbarItems,
            validationGroup: "formsData",
            labelLocation: "left",
            showRequiredMark: false,
          },
          locateinmenu: "auto",
        }
      );
    },
    onToolbarPreparingStocktakeGrid(e) {
      let toolbarItems = e.toolbarOptions.items;
      let searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });

      let itemsToRemoveFromToolBar = [
        "searchPanel",
        "revertButton",
        "saveButton",
      ];

      e.toolbarOptions.items = toolbarItems.filter(
        (item) => !itemsToRemoveFromToolBar.includes(item.name)
      );

      searchPanel.location = "after";

      e.toolbarOptions.items.unshift(
        searchPanel,

        {
          widget: "dxForm",
          location: "before",
          disabled: this.baseView.mode == "review" ? true : false,
          options: {
            formData: this.model,
            items: this.toolbarDetailsFormItems,
            labelLocation: "left",
          },
          locateinmenu: "auto",
        },
        {
          location: "after",
          widget: "dxButton",
          options: {
            icon: "floppy",
            onClick: this.saveStocktake.bind(this),
            validationGroup: "formsData",
          },
        }
      );
    },
    async viewChanged(e) {
      if (this.currentView == e.value) return;
      this.currentView = e.value;

      await this.loadCurrentViewData();
      this.stocktakeGrid.repaint();
    },
    async loadCurrentViewData() {
      if (this.currentView == "Prod Cat 1") {
        await stocktakeCategory1DataSource.load();
        this.stocktakeDataSourceConfig = stocktakeCategory1DataSource.items();
      } else if (this.currentView == "Prod Cat 2") {
        await stocktakeCategory2DataSource.load();
        this.stocktakeDataSourceConfig = stocktakeCategory2DataSource.items();
      } else if (this.currentView == "Prod Cat 3") {
        await stocktakeCategory3DataSource.load();
        this.stocktakeDataSourceConfig = stocktakeCategory3DataSource.items();
      } else if (this.currentView == "Supplier") {
        await stocktakeSupplierDataSource.load();
        this.stocktakeDataSourceConfig = stocktakeSupplierDataSource.items();
      } else if (this.currentView == "Item") {
        await stocktakeItemDataSource.load();
        this.stocktakeDataSourceConfig = stocktakeItemDataSource.items();
      }

      this.stocktakeGrid && this.stocktakeGrid.refresh();
    },
    async saveStocktake() {
      this.$logger.trackEventButtonClickSave();
      let validationResult = await validationEngine.validateGroup("formsData");

      if (!validationResult.isValid) {
        this.displayValidationSummary();
        return;
      }

      if (this.branchGridSelectedData.length === 0) {
        this.displayValidationSummary([
          "Stocktake has no branches selected. Please select one or more branches before attempting to save the transaction again.",
        ]);
        return;
      } else if (this.stocktakeGridSelectedData.length === 0) {
        this.displayValidationSummary([
          "Stocktake has no items selected. Please select one or more items before attempting to save the transaction again.",
        ]);
        return;
      }

      let payload = {
        CountDate: this.model.CountDate.toSaveDate(),
        StocktakeType: this.currentView,
        PrepareStocktakeBranches: this.branchGridSelectedData.map((item) => {
          return { BranchCode: item.Code };
        }),
        PrepareStocktakeDetails: this.stocktakeGridSelectedData.map((item) => {
          return { Code: item.Code };
        }),
      };

      this.$logger.debug(JSON.stringify(payload), "payload");

      this.showLoading(true);

      try {
        let res = await StocktakePrepareService.SaveStocktake(payload);
        if (res) {
          this.showLoading(false);
          this.$notify(
            `Stocktake ${res.data.Code} Successfully Saved`,
            "success"
          );
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: "/stocktake",
          });
        }
      } catch (err) {
        this.displayServerError(err, "Save Stocktake Failed");
      }
    },
  },
};
</script>

<style lang="scss"></style>
